import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const SpaceNameQuery: GraphQLTaggedNode = graphql`
	query SpaceNameQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			name
			key
		}
	}
`;
